import { TrackingEvents } from "@/services/QrCodeService";
import { Fingerprint2 } from "@/utils";
import getQrCodeService from "@/services/QrCodeService";
import { QrCodeObject } from "@/models/QrCodeObject";


export type AppConfig = {
    VUE_APP_API_ROOT?: string;
    VUE_APP_STQR_FE_ROOT?: string;
    VUE_APP_ARGO_EDITOR_URL?: string;
    VUE_APP_BEAR_API?: string;
    VUE_APP_SSO_URL?: string;
    VUE_APP_API_ROOT_BASE?: string;
    VUE_APP_BEAR_API_MEDIA?: string;
    VUE_APP_ADMIN_URL?: string;
    VUE_APP_STATS_URL?: string;
    VUE_APP_BEAR_API_ROOT?: string;
    VUE_APP_API_TOKEN?: string;
    VUE_APP_SBL_API?: string;
};
  
let config: AppConfig | null = null;
async function loadConfig() {
    try {
      const configCustom = await fetch("./app-config.json");
      config = configCustom ? await configCustom.json() : null;
      return config;
    } catch (e) {
      console.warn("Custom config not available. Using env vars.");
    }
}
function getConfigValue<K extends keyof AppConfig>(
    key: K
  ): AppConfig[K] | string | undefined {
    return config && config[key] ? config[key] : process.env[key];
  }
  
let apiEndpoints: any = {};

export function getApiEndpoints() {
    // Return the api endpoints object if it exists, otherwise return undefined.
    return apiEndpoints;
  }
export async function initConfig() {
    await loadConfig();
    apiEndpoints = {
      API_ROOT: getConfigValue("VUE_APP_API_ROOT"),
      API_BASE: getConfigValue("VUE_APP_API_ROOT_BASE"),
      BEAR_MEDIA: getConfigValue("VUE_APP_BEAR_API_MEDIA"),
      BEAR_API_ROOT: getConfigValue("VUE_APP_BEAR_API_ROOT"),
      API_TOKEN: getConfigValue("VUE_APP_API_TOKEN"),
      ADMIN_URL: getConfigValue("VUE_APP_ADMIN_URL"),
      RESET_PASSWORD_SSO: getConfigValue("VUE_APP_SSO_URL") + "auth/reset-password",
      RESET_PASSWORD_STQR: getConfigValue("VUE_APP_API_ROOT") + "auth/reset-password",
      STQR_AUTH: getConfigValue("VUE_APP_API_ROOT") + "auth/token",
      SSO_AUTH: getConfigValue("VUE_APP_SSO_URL") + "auth/token",
      SHORTLINKS: getConfigValue("VUE_APP_API_ROOT") + "shortlinks/crypto-id",
      SHORTLINK_BURNS: getConfigValue("VUE_APP_API_ROOT") + "shortlink-burns",
      SHORTLINK_REPORTS: getConfigValue("VUE_APP_API_ROOT") + "shortlink-reports",
      STATS: getConfigValue("VUE_APP_STATS_URL"),
      USERS: getConfigValue("VUE_APP_SSO_URL") + "users",
      GUESTS: getConfigValue("VUE_APP_API_ROOT") + "guests",
      UPLOADS: getConfigValue("VUE_APP_API_ROOT") + "uploads/presign",
      CREATE_USER: getConfigValue("VUE_APP_API_ROOT") + "auth/guest/create",
      ACTIVATE_USER: getConfigValue("VUE_APP_API_ROOT") + "auth/guest/activate",
      GEO_IP: getConfigValue("VUE_APP_API_ROOT") + "geoip/city",
      WEBAR_URL: getConfigValue("VUE_APP_SBL_API") + "links",
      COMMENTS: getConfigValue("VUE_APP_API_ROOT") + "shortlink-comments",
    };
  }
export function convertSnakeToCamel(obj: any): any {
    // If the input is an array, recursively process each element
    if (Array.isArray(obj)) {
        return obj.map(item => convertSnakeToCamel(item));
    }

    // If the input is an object, process its keys and values
    if (obj !== null && typeof obj === "object") {
        return Object.keys(obj).reduce((result: any, key: string) => {
            const value = obj[key];

            // Convert snake_case key to camelCase
            const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());

            // Recursively process the value if it's an object or array
            result[camelKey] = convertSnakeToCamel(value);

            return result;
        }, {});
    }

    // Return the value as-is if it's not an object or array
    return obj;
}
export function convertCamelToSnake(obj: any): any {
    // If the input is an array, recursively process each element
    if (Array.isArray(obj)) {
        return obj.map(item => convertCamelToSnake(item));
    }

    // If the input is an object, process its keys and values
    if (obj !== null && typeof obj === "object") {
        return Object.keys(obj).reduce((result: any, key: string) => {
            const value = obj[key];

            // Convert camelCase key to snake_case
            const snakeKey = key.replace(/([A-Z])/g, "_$1").toLowerCase();

            result[snakeKey] = value;

            return result;
        }, {});
    }
    if (typeof obj === "string") {
        return obj.replace(/([A-Z])/g, "_$1").toLowerCase();
    }

    // Return the value as-is if it's not an object or array
    return obj;
}

export function sendLog(action: TrackingEvents, qrcodeObject: QrCodeObject, burnId?: string) {
    Fingerprint2.get(components => {
        const values = components.map(component => component.value);
        const fingerprint = Fingerprint2.x64hash128(values.join(""), 31);
        getQrCodeService().logScan(
            fingerprint,
            qrcodeObject.project,
            qrcodeObject.shortlink,
            action,
            burnId
        );
    });
}

export async function getGeoInfo() {
    return await getQrCodeService().getGeo();
}

export function getUserOS() {
    const platform = navigator.platform;
    let osName = "Unknown OS";

    if (platform.includes("Win")) {
        osName = "Windows";
    } else if (platform.includes("Mac")) {
        osName = "MacOS";
    } else if (platform.includes("X11") || platform.includes("Linux")) {
        osName = "Linux";
    }

    return osName;
}
